

function sizeChart(){
  const sizeChartBtns = document.querySelectorAll("[js-size-chart-btn]");
  const popOverlay = document.querySelector(".popOverlay");
  const popContainer = document.querySelector(".chart_popContent");
  const closeBtn = document.querySelector(".closeBtn");
  const body = document.querySelector("body");

  sizeChartBtns.forEach(btn => {
      if (popContainer){
        btn.addEventListener("click", function () {
          popOverlay.classList.add("active");
          popContainer.classList.add("active");
          body.classList.add("noScroll");
        });
        
        function closePopup() {
          popOverlay.classList.remove("active");
          popContainer.classList.remove("active");
          body.classList.remove("noScroll");
        }
        
        popOverlay.addEventListener("click", closePopup);
        closeBtn.addEventListener("click", closePopup);
      }
   })
}
  
sizeChart()
document.addEventListener("sizeChart:init", sizeChart);
